module.exports = __webpack_public_path__ + "static/media/ErrorFixing.49dd88e5.png";